module.exports = __webpack_public_path__ + "img/lv4-1.ee6a163f.png";